import zhCN from 'ant-design-vue/es/locale/zh_CN.js';
import enUS from 'ant-design-vue/es/locale/en_US.js';
import en from '../locales/en.json';
import zh from '../locales/zh.json';

// 合并AntD和自定义语言包
export const locales = {
  zh: {
    antd: zhCN,       // Ant Design 中文包
    ...zh
  },
  en: {
    antd: enUS,       // Ant Design 英文包
    ...en
  }
};

// 获取当前语言环境下的AntD配置
export function getAntdLocale(lang) {
  return locales[lang]?.antd || zh; // 默认返回中文
}